/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_Past_WeekInputs */

const en_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Week`)
};

const fr_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine passée`)
};

const de_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Woche`)
};

const it_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimana scorsa`)
};

const ru_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошедшая неделя`)
};

const es_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La semana pasada`)
};

const zh_cn2_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过去一周`)
};

const ja_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先週`)
};

const hi_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले सप्ताह`)
};

const pt_pt2_date_range_past_week = /** @type {(inputs: Date_Range_Past_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana passada`)
};

/**
* | output |
* | --- |
* | "Past Week" |
*
* @param {Date_Range_Past_WeekInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_past_week = /** @type {((inputs?: Date_Range_Past_WeekInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_Past_WeekInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_date_range_past_week(inputs)
	if (locale === "de") return de_date_range_past_week(inputs)
	if (locale === "it") return it_date_range_past_week(inputs)
	if (locale === "ru") return ru_date_range_past_week(inputs)
	if (locale === "es") return es_date_range_past_week(inputs)
	if (locale === "zh-CN") return zh_cn2_date_range_past_week(inputs)
	if (locale === "ja") return ja_date_range_past_week(inputs)
	if (locale === "hi") return hi_date_range_past_week(inputs)
	if (locale === "pt-PT") return pt_pt2_date_range_past_week(inputs)
	return en_date_range_past_week(inputs)
});